class FileService {
  public open(data: Blob) {
    const link = document.createElement('a');
    if (link) {
      const url = window.URL.createObjectURL(data);
      link.href = url;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return url;
    } else {
      throw new Error('Failed to open a file with the requested data.');
    }
  }

  public download(data: Blob, filename: string) {
    const link = document.createElement('a');
    if (link) {
      // Decode the URL-encoded filename
      const decodedFilename = decodeURIComponent(filename);
      const url = window.URL.createObjectURL(data);
      link.href = url;
      link.setAttribute('download', decodedFilename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      throw new Error('Failed to download a file with the requested data.');
    }
  }

  public openUrl(url: string) {
    const link = document.createElement('a');
    if (link) {
      link.href = url;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return url;
    } else {
      throw new Error(`Failed to open the URL ${url} with the requested data.`);
    }
  }
}

export default new FileService();
